import injectionHelpers from '@carwow/injection-rules-helpers';

import config from '@carwow/injection-default-config';

const isRightNumberOfParagraphs = (options) => {
  const {
    currentRuleInjectedComponentCount: adCount,
    currentRuleComponentTypeWordCount,
    props: { adSettings },
  } = options;

  const {
    numberOfWordsBetweenInlineMobileAds,
    numberOfWordsForFirstInjectionMobile,
    minNumOfWordsAfterLastInlineAdMobile,
  } = adSettings;

  if ((!numberOfWordsBetweenInlineMobileAds && numberOfWordsBetweenInlineMobileAds !== 0)
    || (!numberOfWordsForFirstInjectionMobile && numberOfWordsForFirstInjectionMobile !== 0)
    || (!minNumOfWordsAfterLastInlineAdMobile && minNumOfWordsAfterLastInlineAdMobile !== 0)) return false;

  if (adCount === 0) {
    return currentRuleComponentTypeWordCount >= numberOfWordsForFirstInjectionMobile;
  }

  const enoughWordsBetweenAds = currentRuleComponentTypeWordCount >= numberOfWordsBetweenInlineMobileAds;
  const wordCountFromCurrIdxToEnd = injectionHelpers.getWordCountFromCurrentIdxToEnd({ ...options });
  const enoughWordsAfterTheAd = wordCountFromCurrIdxToEnd >= minNumOfWordsAfterLastInlineAdMobile;

  return enoughWordsBetweenAds && enoughWordsAfterTheAd;
};

const shouldInject = (options) => injectionHelpers.isBetweenTwoTextBlocks({ ...options })
  && isRightNumberOfParagraphs(options);

const mobileAds = {
  id: 'mobile-inline-ads',
  componentType: 'mobileInlineAd',
  condition: (options) => shouldInject(options),
  component: ({
    componentCount: adCount, localConfig = {},
  }) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'mobile-inline-ads',
    props: adCount,
    defaultConfig: config.getMobileAdsConfig(adCount),
  }),
  resetCurrentItemTypeCurrentCounter: true,
};

export default [
  mobileAds,
];
